import React from 'react';

const AboutCertificate = () => {
  return (
    <div className="relative">
      <div className="absolute -inset-4 rounded-full bg-brass/10 blur-2xl" />
      <div className="relative rotate-[-1deg] border-[12px] border-navy bg-cream-light p-4 shadow-2xl">
        <div className="border border-brass/50 p-6 text-center sm:p-8">
          <p className="font-fraunces text-2xl text-navy sm:text-3xl">
            State of Maryland
          </p>
          <p className="mt-2 text-[10px] font-bold uppercase tracking-[0.2em] text-brass">
            Executive Department, Annapolis
          </p>

          <div className="my-8 h-px bg-brass/40" />

          <p className="font-fraunces text-lg italic leading-relaxed text-navy/75">
            Be it known, that reposing great trust and confidence in your
            knowledge, integrity, and love of justice, you are hereby appointed a
          </p>

          <p className="mt-8 font-fraunces text-2xl text-navy sm:text-3xl">
            Carlos M Dasilva
          </p>
          <p className="mt-2 text-xs font-bold uppercase tracking-[0.14em] text-brass">
            Notary Public, Prince George&apos;s County
          </p>

          <div className="mx-auto my-8 flex h-20 w-20 items-center justify-center rounded-full border-2 border-brass text-brass">
            <div className="flex h-14 w-14 items-center justify-center rounded-full border border-brass">
              <span className="font-fraunces text-2xl">M</span>
            </div>
          </div>

          <p className="text-[10px] font-semibold uppercase tracking-[0.12em] text-navy/55">
            Commissioned May 12, 2026, Expires May 12, 2030
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutCertificate;